import React, { useState, useEffect, useContext } from "react";
import { Container, Spinner, Navbar } from "react-bootstrap";
import api from "../axiosConfig"; // path disesuaikan lokasi file
import { UserContext } from "../contexts/UserContext";
import "./UserDashboard.css";
import Sidebar from "../components/common/Sidebar";

// Import tab components
import OverviewTab from "../components/user/tabs/OverviewTab";
import MachinesTab from "../components/user/tabs/MachinesTab";
import ToolsTab from "../components/user/tabs/ToolsTab";
import HistoryTab from "../components/user/tabs/HistoryTab";
import HistoryTools from "../components/user/tabs/HistoryTools";
import ChecksheetTab from "../components/user/tabs/ChecksheetTab";

const UserDashboard = () => {
  const userContext = useContext(UserContext);
  const [activeTab, setActiveTab] = useState("overview");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fungsi logout
  const handleLogout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("User belum login");

        const config = {
          headers: {
            Authorization: "Bearer " + token, // ✅ header harus Bearer
          },
        };

        const res = await api.get("/auth/me", config); // ✅ endpoint lengkap
        setCurrentUser(res.data.user); // sesuai response dari server
      } catch (err) {
        console.error(
          "Error mengambil data pengguna:",
          err.response?.data || err.message,
        );
        setCurrentUser({});
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();

    if (userContext?.fetchSectors) {
      userContext.fetchSectors();
    }
  }, [userContext?.fetchSectors]);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" role="status" variant="primary">
          <span className="visually-hidden">Memuat...</span>
        </Spinner>
      </div>
    );
  }
  console.log("TAB =", activeTab);

  return (
    <div className="user-dashboard-container">
      <Sidebar
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        userRole="user"
        onLogout={handleLogout}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />

      <div className="main-content">
        <Navbar bg="white" expand="lg" className="top-navbar">
          <Container fluid>
            <Navbar.Brand className="fw-bold">
              {activeTab === "overview" && "Selamat Datang"}
              {activeTab === "machines" && "Status Mesin"}
              {activeTab === "tools" && "Status Tools"}
              {activeTab === "history" && "Riwayat Maintenance"}
              {activeTab === "historytools" && "Riwayat Tools"}
              {activeTab === "checksheet" && "Check Sheet Harian"}
            </Navbar.Brand>
          </Container>
        </Navbar>

        <Container fluid className="p-0">
          {activeTab === "overview" && <OverviewTab />}
          {activeTab === "machines" && <MachinesTab />}
          {activeTab === "tools" && <ToolsTab />}
          {activeTab === "history" && <HistoryTab />}
          {activeTab === "historytools" && <HistoryTools />}
          {activeTab === "checksheet" && <ChecksheetTab />}
        </Container>
      </div>
    </div>
  );
};

export default UserDashboard;
